var _style, _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudMigration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1480 600",
    style: {
      enableBackground: "new 0 0 1480 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C7A1C9;}\n\t.st1{fill:#BF223C;}\n\t.st2{fill:#398557;}\n\t.st3{fill:#36393A;}\n\t.st4{fill:#753F83;}\n\t.st5{fill:#2C7CB0;}\n\t.st6{fill:#F38020;}\n\t.st7{fill:#404242;}\n\t.st8{fill:#2B808D;}\n\t.st9{fill:#CEEAEE;}\n\t.st10{fill:#36393A;stroke:#36393A;stroke-width:2;stroke-miterlimit:10;}\n\t.st11{fill:#36393A;stroke:#36393A;stroke-width:1.5389;stroke-miterlimit:10;}\n\t.st12{fill:#9B5CA3;}\n\t.st13{fill:#764082;}\n\t.st14{fill:#36393A;stroke:#36393A;stroke-width:0.8153;stroke-miterlimit:10;}\n\t.st15{fill:#36393A;stroke:#36393A;stroke-width:0.6273;stroke-miterlimit:10;}\n\t.st16{fill:#67C1CE;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 121.64,
    y: 397.27,
    className: "st3",
    width: 17.9,
    height: 13.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.34,
    y: 397.16,
    className: "st3",
    width: 17.9,
    height: 13.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.34,
    y: 371.49,
    className: "st3",
    width: 17.9,
    height: 13.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.64,
    y: 371.6,
    className: "st3",
    width: 17.9,
    height: 13.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.64,
    y: 345.97,
    className: "st3",
    width: 17.9,
    height: 13.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.34,
    y: 345.86,
    className: "st3",
    width: 17.9,
    height: 13.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.34,
    y: 320.12,
    className: "st3",
    width: 17.9,
    height: 13.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.64,
    y: 320.24,
    className: "st3",
    width: 17.9,
    height: 13.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.26,
    y: 361.42,
    className: "st3",
    width: 68.51,
    height: 13.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.26,
    y: 316.95,
    className: "st3",
    width: 68.51,
    height: 13.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.26,
    y: 271.28,
    className: "st3",
    width: 68.51,
    height: 13.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.98,
    y: 300.18,
    className: "st3",
    width: 14.36,
    height: 26.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.49,
    y: 385.09,
    className: "st3",
    width: 14.36,
    height: 26.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.98,
    y: 257.45,
    className: "st3",
    width: 14.36,
    height: 26.34
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.98,
    y: 385.33,
    className: "st3",
    width: 14.36,
    height: 26.34
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.24,
    y: 385.09,
    className: "st3",
    width: 14.36,
    height: 26.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.24,
    y: 342.48,
    className: "st3",
    width: 14.36,
    height: 26.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.24,
    y: 385.33,
    className: "st3",
    width: 14.36,
    height: 26.34
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.98,
    y: 342.71,
    className: "st3",
    width: 14.36,
    height: 26.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.24,
    y: 257.45,
    className: "st3",
    width: 14.36,
    height: 26.34
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.24,
    y: 299.95,
    className: "st3",
    width: 14.36,
    height: 26.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.24,
    y: 300.18,
    className: "st3",
    width: 14.36,
    height: 26.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.24,
    y: 257.22,
    className: "st3",
    width: 14.36,
    height: 26.34
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.24,
    y: 342.71,
    className: "st3",
    width: 14.36,
    height: 26.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.49,
    y: 257.22,
    className: "st3",
    width: 14.36,
    height: 26.34
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.49,
    y: 299.95,
    className: "st3",
    width: 14.36,
    height: 26.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.49,
    y: 342.48,
    className: "st3",
    width: 14.36,
    height: 26.35
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "341.31,435.26 341.31,444.6 327.47,444.6 327.47,435.26 340.21,435.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "446.52,435.26 446.52,444.6 393.22,444.6 341.31,444.6 341.31,435.26 396.95,435.26 410.8,435.26  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.52,
    y: 435.26,
    className: "st3",
    width: 13.85,
    height: 9.34
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.26,
    y: 435.26,
    className: "st3",
    width: 13.85,
    height: 9.34
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "460.37,297.12 460.37,435.26 446.52,435.26 446.52,238.24 341.31,238.24 341.31,435.26  340.21,435.26 327.47,435.26 327.47,224.39 451.12,224.39 460.37,224.39 460.37,283.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "164.72,260.55 164.72,274.39 110.11,274.39 110.11,435.26 96.26,435.26 96.26,260.55  121.67,260.55 135.52,260.55  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M475.64,435.26c3.88,0,7.02,3.15,7.02,7.02c0,3.88-3.14,7.03-7.02,7.03h-0.38H340.21H230.74H79.55h-5.26 c-3.88,0-7.02-3.15-7.02-7.03c0-3.87,3.14-7.02,7.02-7.02h21.97v9.34h13.85v-9.34h54.88V260.55v-63.19h25.41v-44.44h42.2 l6.91-67.63l6.93,67.63h42.2v44.44h25.41v67.34v13.85v156.71h13.42v9.34h13.84h51.91h53.3h13.85v-9.34H475.64z M300.2,435.26 V211.21H178.83v224.05h51.91H300.2z M274.79,197.36v-30.59h-70.55v30.59H274.79z"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1350.52,283.35c39.23,7.14,68.21,41.46,68.21,81.81c0,45.85-37.3,83.15-83.15,83.15h-321.9 c-32.44,0-58.82-26.39-58.82-58.83c0-26.14,17.3-48.97,41.89-56.36c-0.52-3.77-0.78-7.59-0.78-11.41 c0-45.86,37.32-83.16,83.19-83.16c6.68,0,13.29,0.79,19.7,2.35c20.92-47.18,68.64-78.51,120.45-78.51 c34.11,0,66.47,13.04,91.13,36.72C1333.83,221.57,1347.94,251.33,1350.52,283.35z M1406.73,365.16 c0-35.97-26.92-66.34-62.61-70.64l-5.06-0.61l-0.22-5.09c-1.33-30.8-14.36-59.59-36.71-81.05 c-22.41-21.53-51.83-33.38-82.82-33.38c-48.73,0-93.49,30.5-111.38,75.91l-2.06,5.21l-5.33-1.69 c-6.87-2.17-14.07-3.27-21.38-3.27c-39.26,0-71.19,31.92-71.19,71.16c0,4.94,0.51,9.87,1.52,14.65l1.27,5.97l-6,1.16 c-21.96,4.26-37.9,23.6-37.9,45.99c0,25.83,21,46.83,46.82,46.83h321.9C1374.81,436.31,1406.73,404.4,1406.73,365.16z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M725.05,216.84c-53.1,0-96.3,43.2-96.3,96.3s43.2,96.3,96.3,96.3s96.3-43.2,96.3-96.3 S778.15,216.84,725.05,216.84z M799.91,357.66h-29.02c3.16-11.39,5.13-24.18,5.62-37.84h35.39 C810.85,333.56,806.62,346.42,799.91,357.66z M750.79,396.39c6.92-7.25,12.8-17.36,17.2-29.56h25.61 C782.78,380.62,767.91,391.08,750.79,396.39z M656.49,366.83h25.6c4.39,12.2,10.28,22.31,17.2,29.56 C682.17,391.08,667.31,380.62,656.49,366.83z M638.19,319.82h35.39c0.49,13.66,2.45,26.45,5.62,37.84h-29.02 C643.48,346.42,639.24,333.56,638.19,319.82z M648.98,270.72h29.65c-3.14,12.03-4.96,25.54-5.15,39.93h-35.51 C638.39,296.19,642.32,282.6,648.98,270.72z M699.3,229.9c-7.31,7.66-13.45,18.52-17.91,31.65h-26.49 C665.82,246.72,681.32,235.47,699.3,229.9z M795.2,261.55h-26.5c-4.46-13.13-10.6-23.99-17.91-31.65 C768.77,235.47,784.27,246.72,795.2,261.55z M767.43,310.65h-84.78c0.21-14.37,2.24-27.99,5.63-39.93h73.51 C765.19,282.65,767.22,296.27,767.43,310.65z M761.2,357.66h-72.31c-3.41-11.27-5.58-24.17-6.12-37.84h84.55 C766.78,333.49,764.61,346.38,761.2,357.66z M758.01,366.83c-7.85,19.84-19.82,32.78-32.96,32.78s-25.11-12.95-32.96-32.78H758.01z  M691.27,261.55c7.82-21.02,20.17-34.87,33.77-34.87c13.6,0,25.95,13.86,33.77,34.87H691.27z M776.6,310.65 c-0.19-14.39-2.01-27.9-5.15-39.93h29.65c6.65,11.88,10.59,25.47,11,39.93H776.6z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 843.32,
    y: 310.26,
    className: "st3",
    width: 96.7,
    height: 11.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "916.31,336.39 936.5,316.21 916.31,296.03 933.44,296.03 953.63,316.21 933.44,336.39  "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 492.42,
    y: 310.26,
    className: "st3",
    width: 113.81,
    height: 11.9
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudMigration);
export default __webpack_public_path__ + "static/media/cloud-migration.4fd2847628c98288e538945285e9a893.svg";
export { ForwardRef as ReactComponent };